/**
 * Rendering a Google Map from a JSON file.
 *
 * Adding markers to a Google Map using a local JSON file
 */
export default class GoogleMap {
    /**
     * Constructor
     */
    constructor(jsonMarkers, mapCanvas) {
        this._mapCountryCenter = "New Zealand"
        this._infoWindow = new google.maps.InfoWindow();
        this._jsonMarkers = jsonMarkers;
        this._mapCanvas = mapCanvas;
        this._assetsPath = "/wp-content/themes/fweb/assets/img";
        this._icons = {
            normal: {
                icon: `${this._assetsPath}/icon-pin.svg`
            },
            specialist: {
                icon: `${this._assetsPath}/icon-pin-specialist.svg`
            }
        };
    }

    /**
     * Initializing a Google Map.
     */
    initMap() {
        this.plotMarkers(this._jsonMarkers);
    }

    /**
     * Plot marker pins to mapCanvas.
     */
    plotMarkers(m) {      
        const mapCanvas = this._mapCanvas;
        let markers = [];
        let bounds = new google.maps.LatLngBounds();
        let infoWindow = this._infoWindow;

        m.forEach(marker => {
            // const { content, type } = marker;
			var type = 'normal'; // TODO: MAKE DYNAMIC // normal or specialist

			var content = {
				name: marker.title.rendered,
				id: marker.id,
				content: marker.content.rendered,
				contact: marker.acf.fw_retailer_contact_information
			}
            
            var location = content.contact.fw_retailer_google_map;

            if(location && location.lat && location.lng) {
                const position = new google.maps.LatLng(content.contact.fw_retailer_google_map.lat, content.contact.fw_retailer_google_map.lng);
    
                markers.push(this.createMarker(position, content, type, infoWindow));
                bounds.extend(position);
            }
        });

        // If there's no markers center map on defined country
        if (markers.length === 0) {
            const country = this._mapCountryCenter;
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'address': country }, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    mapCanvas.setCenter(results[0].geometry.location);
                }
            });

            return mapCanvas.bounds;
        } else if (markers.length === 1) { // If there's one single market center map around it with a higher zoom
            mapCanvas.setZoom(12);
            return mapCanvas.bounds;
            // return mapCanvas.fitBounds(bounds);
        } else { // If there's multiple markers center map around markers
            return mapCanvas.fitBounds(bounds);
        }
    }

    /**
     * Create marker pin and info window.
     */
    createMarker(position, content, type, infoWindow) {
        const mapCanvas = this._mapCanvas;
        const icons = this._icons;
        const marker = new google.maps.Marker({
            position: position,
            map: mapCanvas,
            icon: icons[type].icon,
            animation: google.maps.Animation.DROP
        });

        const website = content.website != "" ? `<a href="${content.contact.fw_retailer_website}" style="font-family: 'NeueHaasGroteskText Pro'; font-size: 16px; color: #CF000E; letter-spacing: 0; text-decoration:none; font-weight: 500; margin-right: 20px; white-space: nowrap;" target="_blank" data-stockist="${content.name}"><i class="fas fa-globe pe-2"></i>Website</a>` : ``;
        const infoWindowHTML = `<button id="iw-close-btn" class="close closeMarker" style="position: absolute; top:2px; right: 5px; color: #000;">&times;</button>
                  <div style="position: relative; max-width: 320px;">
                    <div style="display:flex; align-items:flex-start; justify-content: space-between;">
                      <div>
                        <div style="font-family: 'NeueHaasGroteskText Pro'; font-size: 16px; font-weight: bold; margin-bottom: 10px;">${content.name}</div>
                        <div style="font-family: 'NeueHaasGroteskText Pro'; font-size: 14px; color: #777777; letter-spacing: 0; margin-bottom: 10px;">${content.contact.fw_retailer_street_address}, ${content.contact.fw_retailer_suburb}, ${content.contact.fw_retailer_city}</div>
                      </div>
                      ` + (type === 'specialist' ? `<div><img src="${this._assetsPath}/icon-specialist.png" width="37" height="70" style="margin-left:8px;"></div>` : '') + `
                   </div>
                    <div style="display:flex; align-items:center;" data-stockist='${content.name}'>
                      <span tabindex="0" data-stockist='${content.name}' class="phone-number" style="font-family: 'NeueHaasGroteskText Pro'; font-size: 16px; color: #CF000E; letter-spacing: 0; text-decoration:none; font-weight: 500; margin-right: 20px; white-space: nowrap; cursor: pointer; outline:none;" data-container="body" data-toggle="popover" data-trigger="focus" data-placement="bottom" data-content="<a class='phone-click' data-stockist='${content.name}' href='tel:${content.fw_retailer_phone}'>${content.fw_retailer_phone}</a>"><i class="fas fa-phone pe-2"></i>Phone</span>
                      ${website}<a href="https://www.google.co.nz/maps/dir/`+ content.contact.fw_retailer_google_map.address.replace(/\s+/g, '+') + `" style="font-family: 'NeueHaasGroteskText Pro'; font-size: 16px; color: #CF000E; letter-spacing: 0; text-decoration:none; font-weight: 500; white-space: nowrap;" target="_blank" data-stockist="${content.name}"><i class="fas fa-map-marker-alt pe-2"></i>Directions</a>
                    </div>
                  </div>`;
        /**
         * Add event listener to markers in order to open info window
         */
        google.maps.event.addListener(marker, 'click', () => {
            window.dataLayer = window.dataLayer || [];

            $('[data-toggle="popover"]').popover('hide');
            infoWindow.setOptions(
                {
                    maxWidth: 312,
                    content: infoWindowHTML
                }
            );
            infoWindow.open(mapCanvas, marker);
            // Enable phone popover once infoWindow is open
            setTimeout(() => {
                $('[data-toggle="popover"]').popover({ html: true })
                    .on('show.bs.popover', function () {
                        window.dataLayer.push({
                            event: 'stockist_phone_view',
                            where_to_buy_stockist: $(this).data('stockist')
                        });
                    });
            }, 150);
            // Fire GA
            var category = document.getElementById("mapCategory");

            window.dataLayer.push({
                event: 'where_to_buy_map_pin_view',
                where_to_buy_location: document.getElementById('mapRegion').value,
                where_to_buy_category: category.options[category.selectedIndex].text
            });
        });

        /**
         * Add custom close infoWindow button
         */
        google.maps.event.addListener(infoWindow, 'domready', function () {
            var closeBtn = $('#iw-close-btn').get();
            google.maps.event.addDomListener(closeBtn[0], 'click', function () {
                $('[data-toggle="popover"]').popover('hide');
                infoWindow.close();
            });
        });
    }
}